export default __webpack_public_path__ + "assets/facade-logement-neuf-moderne-quebec.f2fee413.webp";